/*
 * Built using Themera with the following color values:
 * - gray: C4C4C4
 * - red: E1251B
 * - orange: DD6B20 (default)
 * - yellow: FFB600
 * - green: 82E600
 * - teal: 32C476
 * - cyan: A4E3FF
 * - blue: A4E3FF
 * - purple: 805AD5 (default)
 * - pink: D53F8C (default)
 *
 * - darkBlue: 496480
 * - neutral: 54C0E8
 */

// const colors = {
//     gray: {
//       50: "#F2F2F2",
//       100: "#DBDBDB",
//       200: "#C4C4C4",
//       300: "#ADADAD",
//       400: "#969696",
//       500: "#808080",
//       600: "#666666",
//       700: "#4D4D4D",
//       800: "#333333",
//       900: "#1A1A1A",
//     },
//     yellow: {
//       50: "#FFF8E5",
//       100: "#FFEBB8",
//       200: "#FFDD8A",
//       300: "#FFD05C",
//       400: "#FFC32E",
//       500: "#FFB600",
//       600: "#CC9200",
//       700: "#996D00",
//       800: "#664900",
//       900: "#332400",
//     },
//     green: {
//       50: "#F4FFE5",
//       100: "#E0FFB8",
//       200: "#CCFF8A",
//       300: "#B8FF5C",
//       400: "#A4FF2E",
//       500: "#90FF00",
//       600: "#73CC00",
//       700: "#569900",
//       800: "#3A6600",
//       900: "#1D3300",
//     },
//     teal: {
//       50: "#EBFAF2",
//       100: "#C6F0DA",
//       200: "#A2E7C2",
//       300: "#7DDEAA",
//       400: "#58D592",
//       500: "#34CB7A",
//       600: "#29A362",
//       700: "#1F7A49",
//       800: "#155131",
//       900: "#0A2918",
//     },
//     blue: {
//       50: "#E5F7FF",
//       100: "#B8E9FF",
//       200: "#8ADBFF",
//       300: "#5CCDFF",
//       400: "#2EBFFF",
//       500: "#00B1FF",
//       600: "#008DCC",
//       700: "#006A99",
//       800: "#004766",
//       900: "#002333",
//     },
//     red: {
//       50: "#FCE9E8",
//       100: "#F7C2BF",
//       200: "#F29B96",
//       300: "#EE746D",
//       400: "#E94D44",
//       500: "#E4251B",
//       600: "#B61E16",
//       700: "#891610",
//       800: "#5B0F0B",
//       900: "#2E0705",
//     },
//     cyan: {
//       50: "#E5F7FF",
//       100: "#B8E9FF",
//       200: "#8ADBFF",
//       300: "#5CCDFF",
//       400: "#2EBFFF",
//       500: "#00B1FF",
//       600: "#008DCC",
//       700: "#006A99",
//       800: "#004766",
//       900: "#002333",
//     },
//     darkBlue: {
//       50: "#EFF2F6",
//       100: "#D2DBE5",
//       200: "#B4C4D4",
//       300: "#97ADC4",
//       400: "#7A96B3",
//       500: "#5D7FA2",
//       600: "#4A6582",
//       700: "#384C61",
//       800: "#253341",
//       900: "#131920",
//     },
//     neutral: {
//       50: "#FFF8E5",
//       100: "#FFEBB8",
//       200: "#FFDD8A",
//       300: "#FFD05C",
//       400: "#FFC32E",
//       500: "#FFB600",
//       600: "#CC9200",
//       700: "#996D00",
//       800: "#664900",
//       900: "#332400",
//     },
//   };

const colors = {
  gray: {
    50: "rgba(242,242,242,1)",
    100: "rgba(219,219,219,1)",
    200: "rgba(196,196,196,1)",
    300: "rgba(173,173,173,1)",
    400: "rgba(150,150,150,1)",
    500: "rgba(128,128,128,1)",
    600: "rgba(102,102,102,1)",
    700: "rgba(77,77,77,1)",
    800: "rgba(51,51,51,1)",
    900: "rgba(26,26,26,1)",
  },
  orange: {
    50: "rgba(101,43,25,1)",
    100: "rgba(123,52,30,1)",
    200: "rgba(156,66,33,1)",
    300: "rgba(192,86,33,1)",
    400: "rgba(221,107,32,1)",
    500: "rgba(237,137,54,1)",
    600: "rgba(246,173,85,1)",
    700: "rgba(251,211,141,1)",
    800: "rgba(254,235,200,1)",
    900: " rgba(255,250,240,1)",
  },
  yellow: {
    50: "rgba(255,248,229,1)",
    100: "rgba(255,235,184,1)",
    200: "rgba(255,221,138,1)",
    300: "rgba(255,208,92,1)",
    400: "rgba(255,195,46,1)",
    500: "rgba(255,182,0,1)",
    600: "rgba(204,146,0,1)",
    700: "rgba(153,109,0,1)",
    800: "rgba(102,73,0,1)",
    900: "rgba(51,36,0,1)",
  },
  green: {
    50: "rgba(244,255,229,1)",
    100: "rgba(224,255,184,1)",
    200: "rgba(204,255,138,1)",
    300: "rgba(184,255,92,1)",
    400: "rgba(164,255,46,1)",
    500: "rgba(144,255,0,1)",
    600: "rgba(115,204,0,1)",
    700: "rgba(86,153,0,1)",
    800: "rgba(58,102,0,1)",
    900: "rgba(29,51,0,1)",
  },
  teal: {
    50: "rgba(235,250,242,1)",
    100: "rgba(198,240,218,1)",
    200: "rgba(162,231,194,1)",
    300: "rgba(125,222,170,1)",
    400: "rgba(88,213,146,1)",
    500: "rgba(52,203,122,1)",
    600: "rgba(41,163,98,1)",
    700: "rgba(31,122,73,1)",
    800: "rgba(21,81,49,1)",
    900: "rgba(10,41,24,1)",
  },
  blue: {
    50: "rgba(229,247,255,1)",
    100: "rgba(184,233,255,1)",
    200: "rgba(138,219,255,1)",
    300: "rgba(92,205,255,1)",
    400: "rgba(46,191,255,1)",
    500: "rgba(0,177,255,1)",
    600: "rgba(0,141,204,1)",
    700: "rgba(0,106,153,1)",
    800: "rgba(0,71,102,1)",
    900: "rgba(0,35,51,1)",
  },
  red: {
    50: "rgba(252,233,232,1)",
    100: "rgba(247,194,191,1)",
    200: "rgba(242,155,150,1)",
    300: "rgba(238,116,109,1)",
    400: "rgba(233,77,68,1)",
    500: "rgba(228,37,27,1)",
    600: "rgba(182,30,22,1)",
    700: "rgba(137,22,16,1)",
    800: "rgba(91,15,11,1)",
    900: "rgba(46,7,5,1)",
  },
  cyan: {
    50: "rgba(229,247,255,1)",
    100: "rgba(184,233,255,1)",
    200: "rgba(138,219,255,1)",
    300: "rgba(92,205,255,1)",
    400: "rgba(46,191,255,1)",
    500: "rgba(0,177,255,1)",
    600: "rgba(0,141,204,1)",
    700: "rgba(0,106,153,1)",
    800: "rgba(0,71,102,1)",
    900: "rgba(0,35,51,1)",
  },
  darkBlue: {
    50: "rgba(210,219,229,.2)",
    100: "rgba(210,219,229,1)",
    200: "rgba(180,196,212,1)",
    300: "rgba(151,173,196,1)",
    400: "rgba(122,150,179,1)",
    500: "rgba(93,127,162,1)",
    600: "rgba(74,101,130,1)",
    700: "rgba(56,76,97,1)",
    800: "rgba(37,51,65,1)",
    900: "rgba(19,25,32,1)",
  },
  neutral: {
    50: "rgba(255,248,229,1)",
    100: "rgba(255,235,184,1)",
    200: "rgba(255,221,138,1)",
    300: "rgba(255,208,92,1)",
    400: "rgba(255,195,46,1)",
    500: "rgba(255,182,0,1)",
    600: "rgba(204,146,0,1)",
    700: "rgba(153,109,0,1)",
    800: "rgba(102,73,0,1)",
    900: "rgba(51,36,0,1)",
  },
};

export default colors;
